import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  taxonsLoadRequest: null,
  taxonsLoaded: ['payload'],
}, { prefix: '[TAXONS] ' });
